package com.evoapps.evoshift.billing

import com.evoapps.evoshift.domain.billing.BillingCustomer
import com.evoapps.evoshift.domain.billing.BillingException
import com.evoapps.evoshift.domain.billing.PlanOffer
import com.evoapps.evoshift.domain.repository.BillingRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

/**
 * Billing for a build without a RevenueCat key for its platform (local, emulator and CI builds):
 * nothing can be bought, the paywall says so, and the plan comes only from the Firestore mirror.
 */
class NotConfiguredBillingRepository : BillingRepository {
    override val isConfigured: Boolean = false
    override val customer: StateFlow<BillingCustomer> = MutableStateFlow(BillingCustomer()).asStateFlow()

    override suspend fun identify(uid: String?) = Unit

    private fun <T> notConfigured(): Result<T> = Result.failure(BillingException(BillingException.Reason.NOT_CONFIGURED))

    override suspend fun getOffers(): Result<List<PlanOffer>> = notConfigured()
    override suspend fun purchase(offer: PlanOffer): Result<Unit> = notConfigured()
    override suspend fun restorePurchases(): Result<Unit> = notConfigured()
    override suspend fun manageSubscription(managementUrl: String?): Result<Unit> = notConfigured()
}

/** The platform's billing: the RevenueCat implementation when [apiKey] is set, else [NotConfiguredBillingRepository]. */
internal inline fun billingFor(apiKey: String, create: (String) -> BillingRepository): BillingRepository =
    if (apiKey.isBlank()) NotConfiguredBillingRepository() else create(apiKey.trim())
